<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" label-width="130px" v-loading="loading">
        <h3 class="title">基本信息</h3>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请ID">
              <div>{{ formData.applyId }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请单号">
              <div>{{ formData.applyNo }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请标题">
              <div>{{ formData.applyTitle }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请人">
              <div>{{ formData.applyUserName || '--' }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请时间">
              <div>{{ formData.applyTime }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              <div>{{ formData.createTime }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="签章人">
              <div>{{ formData.userName || '--' }}</div>
            </el-form-item>
          </el-col>
                    <el-col :span="12">
            <el-form-item label="当前状态">
              <el-tag v-if="formData.currentStatus === '1'" type="warning">{{ sealApplyStatusMap.get(formData.currentStatus) }}</el-tag>
              <el-tag v-else-if="formData.currentStatus === '2'" type="success">{{ sealApplyStatusMap.get(formData.currentStatus) }}</el-tag>
              <el-tag v-else-if="formData.currentStatus === '3'" type="info">{{ sealApplyStatusMap.get(formData.currentStatus) }}</el-tag>
              <el-tag v-else-if="formData.currentStatus === '4'" type="danger">{{ sealApplyStatusMap.get(formData.currentStatus) }}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="驳回原因">
              <div>{{ formData.rejectReason || '-' }}</div>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="用印事由描述">
              <div>{{ formData.useDesc }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <h3 class="title">文件列表</h3>
        <el-card v-if="formData.fileList && formData.fileList.length > 0">
          <el-table :data="formData.fileList" size="mini">
            <el-table-column prop="documentId" label="文件ID"></el-table-column>
            <el-table-column prop="title" :show-overflow-tooltip="true" label="文件名称"></el-table-column>
            <el-table-column prop="fileSuffix" label="文件后缀"></el-table-column>
            <el-table-column label="操作">
              <template v-slot="{ row }">
                <el-button type="primary" size="small" @click="downloadFile(row.documentId, row.title, row.fileSuffix)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div v-else class="empty">无文件</div>

        <h3 class="title">审批记录</h3>
        <el-form-item v-if="formData.recordList && formData.recordList.length > 0">
          <el-timeline :reverse="true" placement="top">
            <el-timeline-item placement="top" v-for="(item, index) of formData.recordList" :key="index" :timestamp="item.approvalTime || '--'">
              <el-card>
                <el-row>
                  <el-col :span="24">
                    审批状态：
                    <el-tag v-if="item.approvalStatus === '1'" type="warning">待审批</el-tag>
                    <el-tag v-else-if="item.approvalStatus === '2'" type="success">审批通过</el-tag>
                    <el-tag v-else-if="item.approvalStatus === '3'" type="danger">审批驳回</el-tag>
                  </el-col>
                  <el-col :span="24">
                    审批环节：{{ item.approvalName || '--' }}
                  </el-col>
                  <el-col :span="24">
                    提交人：{{ item.submitter || '--' }}
                  </el-col>
                  <el-col :span="24">
                    审批人：{{ item.approver || '--' }}
                  </el-col>
                  <el-col :span="24">
                    提交时间：{{ item.submitTime || '--' }}
                  </el-col>
                  <el-col :span="24" v-if="item.approvalComments">
                    审批意见：{{ item.approvalComments || '--' }}
                  </el-col>
                </el-row>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-form-item>
        <div v-else class="empty">无审批记录</div>

        <el-row v-if="isApproval">
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button type="primary" v-if="formData.currentStatus === '1'" @click="showApprovalDialog">审批</el-button>
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

    <!-- 审批弹框 -->
    <ApprovalDialog urlType="7" :relatedId="formData.applyId" v-if="showDlg" @closeDlg="showDlg = false" @successSave="loadData" :showDlg="showDlg"></ApprovalDialog>
  </div>
</template>

<script>
import { sealApplyStatus } from '@/utils/dict'
import ApprovalDialog from '@/views/bondRecord/ApprovalDialog'

export default {
  name: 'SealApplyDetail',
  components: { ApprovalDialog },
  data() {
    return {
      formData: {
        applyId: '',
        applyNo: '',
        applyTitle: '',
        applyUserId: '',
        applyTime: '',
        useDesc: '',
        userId: '',
        sealId: '',
        currentStatus: '',
        rejectReason: null,
        createTime: '',
        fileList: [],
        recordList: []
      },
      loading: false,
      showDlg: false,
      sealApplyStatusMap: sealApplyStatus
    }
  },
  computed: {
    isApproval() {
      return this.$route.query.isApproval === 'true'
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      const applyId = this.$route.query.applyId
      if (applyId) {
        this.loading = true
        this.$axios.get(this.$apis.sealApply.selectSealApplyByApplyId, {
          params: {
            applyId
          }
        }).then(res => {
          this.formData = res
        }).finally(() => {
          this.loading = false
        })
      }
    },
    showApprovalDialog() {
      this.showDlg = true
    },
    // 下载文件
    downloadFile(documentId, title, fileSuffix) {
      // 获取电子章请求头
      this.$axios.get(this.$apis.sealApply.selectqiyuesuo).then(res => {
        const headers = {
          'x-qys-open-accesstoken': res['x-qys-open-accesstoken'],
          'x-qys-open-signature': res['x-qys-open-signature'],
          'x-qys-open-timestamp': res['x-qys-open-timestamp'],
          'x-qys-open-nonce': res['x-qys-open-nonce']
        }
        const loadingInstance = this.$loading({
          lock: true,
          text: '下载中...',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        // 调用契约锁文件下载接口
        this.$axios.get('/v2/document/download', {
          documentId
        }, {
          headers: headers,
          responseType: 'blob'
        }).then(response => {
          // 创建下载链接
          const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${title}.pdf`)
          document.body.appendChild(link)
          link.click()
          // 清理
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
        }).catch(error => {
          this.$message.error('文件下载失败：' + error.message)
        }).finally(() => {
          loadingInstance.close()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0 10px 0;
  color: #333;
}
.empty {
  text-align: center;
  padding: 20px;
  color: #999;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin: 10px 0;
}
</style>
